import { isOfflineModeAllowed } from '@/utils/offline-mode';
import { useUserContext } from '@/contexts/user-context';

export const useOfflineModeEnabled = () => {
  const { selectedRestaurantRelationship } = useUserContext();
  return isOfflineModeAllowed && selectedRestaurantRelationship.showOfflineMode;
};
